import { useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';

import { searchKeys } from '@/shared/utils/search-parameters';

import { initDataLayer } from './data-layer';
import { isTrackableLocation, loadGoogleTagManager, resolveGtmId } from './gtm';

const readAppId = () => {
  try {
    return sessionStorage.getItem(searchKeys.appId) ?? undefined;
  } catch {}
};

/**
 * 環境に応じた GTM コンテナを読み込む。対象外のホストでは何もしない (dataLayer も作らない)。
 *
 * NOTE: `app_id` が App.tsx のモジュール評価時に sessionStorage へ移されるため、描画後に解決する。
 */
const GoogleTagManager = () => {
  const { search, hash } = useLocation();

  const gtmId = useMemo(() => resolveGtmId(window.location.hostname, readAppId()), []);

  useEffect(() => {
    if (!gtmId) {
      return;
    }

    // 読み込み前に積んだイベントは、GTM が読み込まれた時点で処理される
    initDataLayer();

    if (isTrackableLocation(search, hash)) {
      loadGoogleTagManager(gtmId);
    }
  }, [gtmId, search, hash]);

  return null;
};

export default GoogleTagManager;
